import { c as _c } from "react/compiler-runtime";
import { useMatch } from '@tanstack/react-router';
import { trackClick, trackPageView, trackTimeSpent } from '@/idv2/utils/analytics';
import { useAppNavigate } from './use-app-navigate';
import { useIsLoading } from './use-is-loading';
export const useFootprint = () => {
  const $ = _c(12);
  const {
    forward,
    back,
    close,
    identifyCanGoBack
  } = useAppNavigate();
  const isLoading = useIsLoading();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      from: "/onboarding/$token",
      shouldThrow: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onboardingMatch = useMatch(t0);
  const canGoBack = (onboardingMatch?.context?.canGoBack ?? false) || identifyCanGoBack;
  let t1;
  if ($[1] !== canGoBack) {
    t1 = {
      onboarding: {
        canGoBack
      }
    };
    $[1] = canGoBack;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      trackClick,
      trackPageView,
      trackTimeSpent
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== back || $[5] !== close || $[6] !== forward) {
    t3 = {
      forward,
      back,
      close
    };
    $[4] = back;
    $[5] = close;
    $[6] = forward;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isLoading || $[9] !== t1 || $[10] !== t3) {
    t4 = {
      isLoading,
      data: t1,
      analytics: t2,
      navigation: t3
    };
    $[8] = isLoading;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};